import React, { useEffect, useState } from "react";
import { Camera, Download, Loader2 } from "lucide-react";
import { getMyPhotos } from "../../api";
import { SectionCard } from "./PortalShared";

const PortalPhotography = () => {
  const [photos, setPhotos] = useState(null);
  useEffect(() => { getMyPhotos().then(setPhotos).catch(() => setPhotos([])); }, []);

  if (photos === null) return <div className="flex items-center justify-center py-16 text-[#8a8a8a]"><Loader2 className="animate-spin mr-2" size={18} /> Loading your photography…</div>;

  return (
    <SectionCard title="Your Property Photography">
      {photos.length === 0 ? (
        <div className="text-center py-12" data-testid="portal-photos-empty">
          <Camera size={30} className="text-[#d0c8b8] mx-auto mb-3" />
          <p className="text-[14px] text-[#8a8a8a]">Your agent hasn't shared any photography yet. Professional shots of your property will appear here.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-testid="portal-photos-grid">
          {photos.map((p) => (
            <a key={p.id} href={p.url} target="_blank" rel="noreferrer" download className="group relative rounded-xl overflow-hidden border border-[#f0ece5] bg-[#faf7f2] aspect-[4/3]" data-testid={`portal-photo-${p.id}`}>
              <img src={p.url} alt={p.caption || p.filename} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <span className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                <Download size={20} className="text-white opacity-0 group-hover:opacity-100 transition-opacity" />
              </span>
              {p.caption && <span className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent px-2 py-1.5 text-[11px] text-white truncate">{p.caption}</span>}
            </a>
          ))}
        </div>
      )}
    </SectionCard>
  );
};

export default PortalPhotography;
